import React from "react";
import "./App.css";
import WhatsappLogo from '../images/whatsapp-icon.png';
import InstagramLogo from '../images/insta-icon.png';
import TiktokLogo from '../images/tiktok-icon.png';
import GymHouseLogo from '../images/gymHouse-logo.png';
import GoogleMapsLogo from '../images/GoogleMaps-icon.png';
import fadyPhoto from '../images/Team/fadyAtallah.png';
import doryPhoto from '../images/Team/CoachDory.jpg';
import joePhoto from '../images/Team/CoachJoe.jpg';
import emilioPhoto from '../images/Team/CoachEmilio.jpg';
import coachesGenPic from '../images/Team/FitnessInstructor.jpeg'
import { useNavigate } from "react-router-dom";


export default function Coaches() {


  
    const navigate = useNavigate();

    return (
     
        
        
            <div className="default-page">
            <img onClick={()=>{navigate('/')}} alt="Welcome to GymHouse" className="gymHouse-Logo" src={GymHouseLogo}></img>
              <h1><b>Our Coaches</b></h1>
              <div className="spacer"></div>
              <div className="spacer"/>
              <h2><b>Meet us!</b></h2>
              <div className="spacer"/>
              <div className="spacer"/>
              <hr/>
              <div className="spacer"/>
              
                <div className="meet-us-container">
                {}
                <li><img onClick={()=>{                 
                  navigate('/Coaches/Form?coachName=fady')}} alt="Meet our founder" className="photos" src={fadyPhoto}></img><p>Fady Atallah</p></li>
                <li><img  onClick={()=>{                 
                  navigate('/Coaches/Form?coachName=joe')}} alt="Meet our founder" className="photos" src={joePhoto}></img><p>Joe Kassab</p></li>
                <li><img  onClick={()=>{                 
                  navigate('/Coaches/Form?coachName=emilio')}} alt="Meet our founder" className="photos" src={emilioPhoto}></img><p>Emilio Kassab</p></li>
                <li><img  onClick={()=>{                 
                  navigate('/Coaches/Form?coachName=dory')}} alt="Meet our founder"className="photos" src={doryPhoto}></img><p>Dory Jabbour</p></li>        
                {/* <li><img  onClick={()=>{                 
                  navigate('/Coaches/Form?coachName=ranime')}} alt="Meet our founder" className="photos" src={ranimePhoto}></img><p>Ranime Najem</p></li> */}
                <li><img onClick={()=>{                 
                  navigate('/Coaches/ApplyForm')}} alt="Meet our founder" className="photos" src={coachesGenPic}></img><p>Join us as a Coach</p></li>
             
                </div>
                <hr/>
                <div className="spacer"/>
                <h2><b>Join us as a coach!</b></h2>
                <div className="spacer"/>
                <h3>It will be our pleasure to meet you and help you reach your goals if you are a certified coach and:</h3>
                <li>You need a place to coach your clients</li>
                <li>You need more clients</li>
                <li>You need simply to join our community</li>
                <li>You want to help us educate more people</li>
                
                <div className="spacer"/>
                <hr/>
                <h2><b>How to find us?</b></h2>
                <div className="icons-container">
                <div></div>
                <li><a target="blank" href="https://wa.me/+96171453095" ><img alt="Reach us on Whatsapp" className="icons" src={WhatsappLogo}></img></a></li>
                <li><a target="blank" href="https://www.instagram.com/gymhouse_lb?igsh=MWpsaGZzOXppM3I5Zg%3D%3D&utm_source=qr"><img alt="Reach us on Instagram" className="icons" src={InstagramLogo}></img></a> </li>
                <li><a target="blank" href="https://www.tiktok.com/@gymhouse_lb?_t=8j1PECEQvuE&_r=1"><img alt="Reach us on Tiktok" className="icons" src={TiktokLogo}></img></a> </li>
                <li><a target="blank" href="https://maps.app.goo.gl/JEc6kySrX7HA9N1S8 " ><img alt="Find us on GoogleMaps" className="icons" src={GoogleMapsLogo}></img></a></li>
                <div></div>
                </div>
                <hr/>
                
             
              
              </div>
                            
           
          

         
         

        
    );
  }

